export enum Languages {
    Czech = 'cz',
    English = 'en',
    German = 'de',
    Polish = 'pl',
}
